import { isMobileDevice } from "../../services/utils";
import CustomDrawer from "../CustomDrawer";
import Modal from "../Modal";

const MobileDesktopModalWrapper = ({
  children,
  handleModalToggle,
  isCloseButton,
  closeBtnStyle,
  modalWidth,
  isDrawer = false,
  className,
  backdropClose = true,
  keepOutsideClickEvent = false,
  isModalInMobile = false
}) => {
  const isMobile = isMobileDevice();
  if (!isModalInMobile && (isMobile || isDrawer)) {
    return (
      <CustomDrawer
        isCloseButton={isCloseButton}
        toggleDrawer={handleModalToggle}
        anchor={!isMobile ? "right" : "bottom"}
        isOpen
        closeBtnStyle={closeBtnStyle}
        customClass={className}
        backdropClose={backdropClose}
      >
        {children}
      </CustomDrawer>
    );
  }
  return (
    <Modal
      modalWidth={modalWidth}
      handleModalToggle={handleModalToggle}
      isCloseButton={isCloseButton}
      className={className}
      closeBtnStyle={closeBtnStyle}
      keepOutsideClickEvent={keepOutsideClickEvent}
    >
      {children}
    </Modal>
  );
};
export default MobileDesktopModalWrapper;
